<template>
  <div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-50">
        <md-field :class="!checkPercentage(typeInfo.cover) ? 'md-invalid' : ''">
          <label for="cover">{{ $t("typeInfo.cover.pastures") }} %</label>
          <md-input type="number" name="cover" v-model="typeInfo.cover" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-100)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-50">
        <md-field>
          <select v-model="typeInfo.plot_area" name="plotArea">
            <option disabled value="">{{ $t("typeInfo.plotArea") }}</option>
            <option v-for="area in areas" :value="area" :key="area">{{ area }} m²</option>
          </select>
        </md-field>
      </div>

      <!-- number -->
      <div class="md-layout-item md-size-20">
        <md-field :class="!checkRange(typeInfo.trees_nr, 0, 99999) ? 'md-invalid' : ''">
          <label for="treesNr">{{ $t("typeInfo.trees") }} N°</label>
          <md-input type="number" name="treesNr" v-model="typeInfo.trees_nr" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-99999)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-20">
        <md-field :class="!checkRange(typeInfo.shrubs_nr, 0, 99999) ? 'md-invalid' : ''">
          <label for="shrubsNr">{{ $t("plot.plotTypeList.shrubs") }} N°</label>
          <md-input type="number" name="shrubsNr" v-model="typeInfo.shrubs_nr" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-99999)</span>
        </md-field>
      </div>

      <!-- sp -->
      <div class="md-layout-item md-size-20">
        <md-field :class="!checkPercentage(typeInfo.species_gramin) ? 'md-invalid' : ''">
          <label for="spGramin">{{ $t("typeInfo.spGramin") }} %</label>
          <md-input type="number" name="spGramin" v-model="typeInfo.species_gramin" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-100)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-20">
        <md-field :class="!checkPercentage(typeInfo.species_legum) ? 'md-invalid' : ''">
          <label for="spLegum">{{ $t("typeInfo.spLegum") }} %</label>
          <md-input type="number" name="spLegum" v-model="typeInfo.species_legum" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-100)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-20">
        <md-field :class="!checkPercentage(typeInfo.species_others) ? 'md-invalid' : ''">
          <label for="spOthers">{{ $t("typeInfo.spOthers") }} %</label>
          <md-input type="number" name="spOthers" v-model="typeInfo.species_others" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-100)</span>
        </md-field>
      </div>

      <!-- weight -->
      <div class="md-layout-item md-size-25">
        <md-field :class="!checkWeight(typeInfo.weight_n) ? 'md-invalid' : ''">
          <label for="weightN">{{ $t("typeInfo.weightN") }} (gr)</label>
          <md-input type="number" step="0.01" name="weightN" v-model="typeInfo.weight_n" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-10000)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-25">
        <md-field :class="!checkWeight(typeInfo.weight_e) ? 'md-invalid' : ''">
          <label for="weightE">{{ $t("typeInfo.weightE") }} (gr)</label>
          <md-input type="number" step="0.01" name="weightE" v-model="typeInfo.weight_e" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-10000)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-25">
        <md-field :class="!checkWeight(typeInfo.weight_s) ? 'md-invalid' : ''">
          <label for="weightS">{{ $t("typeInfo.weightS") }} (gr)</label>
          <md-input type="number" step="0.01" name="weightS" v-model="typeInfo.weight_s" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-10000)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-25">
        <md-field :class="!checkWeight(typeInfo.weight_w) ? 'md-invalid' : ''">
          <label for="weightW">{{ $t("typeInfo.weightW") }} (gr)</label>
          <md-input type="number" step="0.01" name="weightW" v-model="typeInfo.weight_w" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-10000)</span>
        </md-field>
      </div>

      <div class="md-layout-item md-size-100">
        <toggle-buttons :btnList="stoneCoverList" :label="$t('typeInfo.stoneCover')" @btnValue="getStoneCover" :editTB="typeInfo.stone_cover" />
      </div>

      <div class="md-layout-item md-size-100">
        <toggle-buttons :btnList="fireStateList" :label="$t('typeInfo.fireState')" @btnValue="getFireState" :editTB="typeInfo.fire_state" />
      </div>

      <div class="md-layout-item md-size-50">
        <toggle-buttons :btnList="pastureUserList" :label="$t('typeInfo.pastureUser')" @btnValue="getPastureUser" :editTB="typeInfo.pasture_user" />
      </div>
      <div class="md-layout-item md-size-50">
        <toggle-buttons :btnList="pastureUtilizPeriodList" :label="$t('typeInfo.pastureUtilizPeriod')" @btnValue="getPastureUtilizPeriod" :editTB="typeInfo.pasture_utiliz_period" />
      </div>

      <div class="md-layout-item md-size-25">
        <md-field :class="!checkAvh(typeInfo.avg_height) ? 'md-invalid' : ''">
          <label for="avh">{{ $t("typeInfo.avh") }} (cm)</label>
          <md-input type="number" step="0.01" name="avh" v-model="typeInfo.avg_height" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-200)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-75">
        <md-field>
          <select v-model="typeInfo.pasture_type" name="pastureType">
            <option disabled value="">{{ $t("typeInfo.pastureType") }}</option>
            <option v-for="(type, key) in pastureTypeList" :value="key" :key="key">{{ type }}</option>
          </select>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-gutter md-alignment-center-center">
      <md-button class="md-raised md-primary" @click="addNw()">{{ btnAddNw }}</md-button>
    </div>

    <error-dialog :show="error" :text="$t('error.dataCheck')" @closeError="error = false" />
  </div>
</template>

<script>
import ToggleButtons from '@/components/ToggleButtons'
import ErrorDialog from '@/components/ErrorDialog'

import EventBus from '@/event-bus'
import { getDomain } from '@/assets/scripts/domainsManager'
import { checkPercentage, checkWeight, checkAvhPasture, checkRange, normalize } from '@/assets/scripts/formatData'

const STONE_COVER = 'pasture_stone_cover'
const FIRE_STATE = 'pasture_fire_state'
const PASTURE_USER = 'pasture_user'
const PASTURE_UTILIZ_PERIOD = 'pasture_utiliz_period'
const PASTURE_TYPE = 'pasture_type'

export default {
  props: ['radius'],
  components: {
    ToggleButtons,
    ErrorDialog
  },
  data: () => ({
    typeInfo: {
      cover: null,
      plot_area: 25,
      plot_radius: null,
      species_gramin: null,
      species_legum: null,
      species_others: null,
      weight_n: null,
      weight_e: null,
      weight_s: null,
      weight_w: null,
      fire_state: '',
      stone_cover: '',
      pasture_user: '',
      pasture_utiliz_period: '',
      pasture_type: '',
      avg_height: null,
      trees_nr: null,
      shrubs_nr: null
    },
    areas: [
      25,
      200,
      400
    ],
    btnAddNw: '',
    stoneCoverList: {},
    fireStateList: {},
    pastureUserList: {},
    pastureUtilizPeriodList: {},
    pastureTypeList: {},
    edit: false,
    checkPercentage: checkPercentage,
    checkWeight: checkWeight,
    checkAvh: checkAvhPasture,
    checkRange: checkRange,
    error: false
  }),
  mounted () {
    this.typeInfo.plot_radius = this.radius
    this.$store.state.plot.id === null ? this.edit = false : this.edit = true
    this.setLists()

    if (this.edit) {
      this.typeInfo = this.$store.state.plot.typeInfo // ref to store
    }

    if (this.edit && this.$store.state.plot.typeInfo.nonwood !== undefined) { // existing nonwood to edit
      this.btnAddNw = this.$i18n.t('global.edit') + ' ' + this.$i18n.t('plot.plotTypeList.nonwood')
    } else {
      this.btnAddNw = this.$i18n.t('global.add') + ' ' + this.$i18n.t('plot.plotTypeList.nonwood')
    }

    EventBus.$on('save', () => {
      this.saveData()
    })
  },
  computed: {
    area () {
      return this.typeInfo.plot_area
    }
  },
  watch: {
    area () {
      this.$emit('area', this.typeInfo.plot_area)
    },
    radius: function () {
      this.typeInfo.plot_radius = this.radius
    }
  },
  methods: {
    saveData: function () {
      if (this.checkData()) {
        if (this.typeInfo.cover !== null) this.typeInfo.cover = normalize(this.typeInfo.cover, 0)
        if (this.typeInfo.trees_nr !== null) this.typeInfo.trees_nr = normalize(this.typeInfo.trees_nr, 0)
        if (this.typeInfo.shrubs_nr !== null) this.typeInfo.shrubs_nr = normalize(this.typeInfo.shrubs_nr, 0)
        if (this.typeInfo.species_gramin !== null) this.typeInfo.species_gramin = normalize(this.typeInfo.species_gramin, 0)
        if (this.typeInfo.species_legum !== null) this.typeInfo.species_legum = normalize(this.typeInfo.species_legum, 0)
        if (this.typeInfo.species_others !== null) this.typeInfo.species_others = normalize(this.typeInfo.species_others, 0)
        // send data only in new
        this.edit ? this.$emit('typeInfo', null) : this.$emit('typeInfo', this.typeInfo)
      } else {
        this.error = true
      }
    },

    setLists: function () {
      getDomain(STONE_COVER).then(data => {
        this.stoneCoverList = data[this.$i18n.locale]
      })
      getDomain(FIRE_STATE).then(data => {
        this.fireStateList = data[this.$i18n.locale]
      })
      getDomain(PASTURE_USER).then(data => {
        this.pastureUserList = data[this.$i18n.locale]
      })
      getDomain(PASTURE_UTILIZ_PERIOD).then(data => {
        this.pastureUtilizPeriodList = data[this.$i18n.locale]
      })
      getDomain(PASTURE_TYPE).then(data => {
        this.pastureTypeList = data[this.$i18n.locale]
      })
    },

    addNw: function () {
      // send the tmp info to the parent only in new
      this.edit ? this.$emit('tmpInfo', null) : this.$emit('tmpInfo', this.typeInfo)
    },

    getFireState: function (value) {
      this.typeInfo.fire_state = value
    },

    getStoneCover: function (value) {
      this.typeInfo.stone_cover = value
    },

    getPastureUser: function (value) {
      this.typeInfo.pasture_user = value
    },

    getPastureUtilizPeriod: function (value) {
      this.typeInfo.pasture_utiliz_period = value
    },

    checkData: function () {
      return checkPercentage(this.typeInfo.cover) &&
        checkRange(this.typeInfo.trees_nr, 0, 99999) &&
        checkRange(this.typeInfo.shrubs_nr, 0, 99999) &&
        checkPercentage(this.typeInfo.species_gramin) &&
        checkPercentage(this.typeInfo.species_legum) &&
        checkPercentage(this.typeInfo.species_others) &&
        checkWeight(this.typeInfo.weight_e) &&
        checkWeight(this.typeInfo.weight_n) &&
        checkWeight(this.typeInfo.weight_w) &&
        checkWeight(this.typeInfo.weight_s) &&
        checkAvhPasture(this.typeInfo.avg_height)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';
</style>
